<div fxLayout="row" [ngClass]="moved ? 'export-docs-box-moved' : 'export-docs-box' "
    *ngIf="selectedDocs$|async;let selectedDocs">
    <div fxLayout="column" *ngIf="selectedDocs?.length > 0" class="export-docs-box-padding">
        <div>{{'claims-center.claimDocumentation.selectedDocsForExportCounter' | translate}} : {{selectedDocs?.length}}
            <button kendoButton type="button"  icon="delete" (click)="removeAllDocuments()"> </button>
            <button kendoButton *ngIf="!moved" type="button" icon="arrow-60-up"  look="flat" (click)="move()"> </button>
            <button kendoButton *ngIf="moved" type="button" icon="arrow-60-down"  look="flat" (click)="move()"> </button>
        </div>
        <div>
            <button kendoButton type="button" (click)="showExportDialog()" class="export-docs-box-button">
                <img alt="export" src="./assets/img/export_docs_icon.png"
                    [width]="32" />{{'claims-center.claimDocumentation.exportDocumentsDialog' | translate}}
            </button>
            
        </div>

    </div>
</div>

<div kendoDialogContainer #exportDialog></div>